const InsuranceThresholdTypes = {
  OVERALL: 'OVERALL',
  INDIVIDUAL: 'INDIVIDUAL',
};

module.exports = { InsuranceThresholdTypes };
